import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export default function Footer({ hasChanged, onSubmit, onUndo }) {
  const navigate = useNavigate();

  return (
    <footer className='app-footer fixed-bottom'>
      <Container className='d-flex justify-content-between align-items-center'>
        
        {/* Botón volver atrás */}
        <Button
          type='button'
          variant='outline-primary'
          onClick={() => navigate('/soil_analyses')}
        >
          Volver
        </Button>

        {/* Acciones principales */}
        <div className='d-flex gap-2'>
          {hasChanged ? (
            <Button type='submit' className='btn-main'>Guardar</Button>
          ) : (
            <Button type='button' className='btn-saved' disabled>Guardado</Button>
          )}
          <Button
            type='button'
            className='btn-soft-clay'
            onClick={onUndo}
            disabled={!hasChanged}
          >
            Deshacer
          </Button>
        </div>
      </Container>
    </footer>
  );
}